import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import { Error as ErrorIcon, CheckCircle as CheckIcon } from "@mui/icons-material";
import { grey, yellow } from "@mui/material/colors";

interface ReconciliationDispatchStatusChipProps {
  isLoading: boolean;
  shippingStatus: string | null;
}

export const ReconciliationDispatchStatusChip = (props: ReconciliationDispatchStatusChipProps) => {
  const { isLoading, shippingStatus } = props;

  if (isLoading) {
    return (
      <Chip
        size="small"
        icon={
          <CircularProgress
            size={16}
            thickness={6}
            sx={{ color: grey[500] }}
          />
        }
        label="CHECKING"
      />
    );
  }

  if (!shippingStatus) {
      <Chip
        size="small"
        icon={<ErrorIcon />}
        label="UNKNOWN"
      />
  }

  if (shippingStatus === "SHIPPED") {
    return (
      <Chip
        size="small"
        color="success"
        icon={<CheckIcon />}
        label={shippingStatus}
      />
    );
  }

  if (shippingStatus === "NOT SHIPPED") {
    return (
      <Chip
        size="small"
        sx={{ background: yellow[800], color: "#fff" }}
        icon={<ErrorIcon sx={{ fill: "#fff" }} />}
        label={shippingStatus}
      />
    );
  }

  return (
    <Chip
      size="small"
      icon={<ErrorIcon />}
      label="UNKNOWN"
    />
  );
};
